import { Injectable, inject } from '@angular/core';
import { Observable, tap, switchMap, of, map } from 'rxjs';
import { PaymentsCommonService } from '../../../../services/payments/payments-common.service';
import { IPaymentDetails } from '../../../../interfaces/payment.interface';
import { Account } from '../../../account/domain/model/account.model';
import { Payment } from '../../domain/model/payment.model';
import { Ticket } from '../../../ticket/domain/model/ticket.model';
import { PaymentTrackerService } from './payment-tracker.service';

@Injectable({ providedIn: 'root' })
export class PaymentTicketService {
  private readonly paymentsCommon = inject(PaymentsCommonService);
  private readonly paymentTracker = inject(PaymentTrackerService);

  generateTicket(
    paymentDetails: IPaymentDetails,
    account: Account,
    payment: Payment
  ): Observable<Ticket | null> {
    return this.paymentsCommon.handleTicketGeneration(paymentDetails, account, payment).pipe(
      switchMap(ticket =>
        ticket ? this.persistTicket(ticket) : of(null)
      )
    );
  }

  private persistTicket(ticket: Ticket): Observable<Ticket> {
    return this.paymentsCommon.handleTicketInsertion(ticket, true).pipe(
      tap(() => this.paymentTracker.trackTicketGenerated(ticket.serie, ticket?.id)),
      map(() => ticket)
    );
  }
}
